import { render, staticRenderFns } from "./ModalEditEventTags.vue?vue&type=template&id=2db28bbb&scoped=true"
import script from "./ModalEditEventTags.vue?vue&type=script&lang=js"
export * from "./ModalEditEventTags.vue?vue&type=script&lang=js"
import style0 from "./ModalEditEventTags.vue?vue&type=style&index=0&id=2db28bbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db28bbb",
  null
  
)

export default component.exports